import { reverse } from '@utils/helper';

const API_STATUS_MAP = {
  10000: 'SUCCESS',
  13004: 'NOT_LOGGED_IN',
  21029: 'REPEAT_OPERATION'
}

const REVERSE_API_STATUS_MAP = reverse(API_STATUS_MAP)

export default {
  API_STATUS_MAP, REVERSE_API_STATUS_MAP
}

export {
  API_STATUS_MAP, REVERSE_API_STATUS_MAP
}
